export const ADD_TO_TEMPLATE_LIST = 'ADD_TO_TEMPLATE_LIST';
export const CATEGORY_MENU_LIST = 'CATEGORY_MENU_LIST';
export const DETECT_WINDOW_SIZE = "DETECT_WINDOW_SIZE";
export const PAGE_LABELS = 'PAGE_LABELS';
export const VIEW_PREFERENCE = 'VIEW_PREFERENCE';
export const CLOSE_SUGGESTIONS='CLOSE_SUGGESTIONS';
